export const formatCount = (count) => {
    if (count < 10000) {
        return new Intl.NumberFormat("en-US").format(count);
    }

    return new Intl.NumberFormat("en-US", {
        notation: "compact",
        maximumFractionDigits: count < 100000 ? 1 : 0,
    }).format(count);
};